import landscapeColors from 'zignal-landscape/lib/styles/colors.css';

const COLORS_BY_SENTIMENT = {
  'Very Positive': landscapeColors.green03,
  'Slightly Positive': landscapeColors.green02,
  'Positive': landscapeColors.green01,
  'Neutral': landscapeColors.orange02,
  'Negative': landscapeColors.red01,
  'Slightly Negative': landscapeColors.red02,
  'Very Negative': landscapeColors.red03,
  'Unknown': landscapeColors.blue02,
};

export {
  COLORS_BY_SENTIMENT,
};
